document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-al-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-al-membership-cta]').forEach(button => button.addEventListener('click', () => {
    const notice = document.querySelector('.al-membership-notice');
    if(notice) { notice.hidden = false; notice.scrollIntoView({behavior:'smooth',block:'center'}); }
  }));
  document.querySelectorAll('.accordion__tab').forEach(button => {
    const panel = button.closest('.accordion-wrapper')?.querySelector('.accordion__panel');
    if(!panel) return;
    const toggle = expanded => {
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
      panel.style.display = expanded ? 'block' : 'none';
      button.closest('.accordion-wrapper').classList.toggle('active', expanded);
    };
    toggle(false);
    button.addEventListener('click', () => toggle(button.getAttribute('aria-expanded') !== 'true'));
  });
  if(new URLSearchParams(location.search).get('request') === 'membership-cancellation') {
    const field = document.getElementById('ContactForm-body');
    if(field && !field.value) field.value = window.ameleContactCancellation || '';
  }
  const money = value => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(value / 100) + ' USD';
  document.querySelectorAll('[data-al-product]').forEach(element => {
    const product = JSON.parse(element.textContent);
    const main = element.closest('#MainContent') || document;
    const picker = main.querySelector('[data-al-picker]');
    const forms = [...main.querySelectorAll('[data-al-product-form]')];
    const select = () => {
      const options = picker ? [...picker.querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value).filter(Boolean) : [];
      const variant = product.variants.find(v => options.every((option, index) => option === v.options[index])) || product.variants[0];
      forms.forEach(form => {
        const input = form.querySelector('[name="id"]');
        if(input) input.value = variant.id;
        form.querySelectorAll('button[type="submit"]').forEach(button => {
          button.disabled = !variant.available;
          const span = button.querySelector('span');
          if(span) span.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        });
      });
      const price = main.querySelector('product-info .price');
      if(price) {
        const discounted = variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', discounted);
        price.querySelectorAll('.price__regular .price-item--regular').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price-item--sale').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price__sale .price-item--regular').forEach(el => el.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '');
      }
      if(variant.featured_image) {
        const image = main.querySelector('.product__media img');
        if(image) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
      }
    };
    picker?.addEventListener('change', select);
    select();
    forms.forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if(button?.disabled) return;
      const error = main.querySelector('.al-product-error') || document.createElement('p');
      error.className = 'al-product-error';
      error.setAttribute('role','alert');
      try {
        const result = await fetch(window.routes.cart_add_url + '.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
        const body = await result.json();
        if(!result.ok) throw new Error(body.description || body.message);
        location.assign(window.routes.cart_url);
      } catch(e) {
        error.textContent = e.message;
        form.append(error);
      }
    }));
  });
  document.querySelectorAll('#cart-icon-bubble').forEach(link => link.href = window.routes.cart_url);
  document.querySelectorAll('form[action="/cart/add"]:not([data-al-product-form])').forEach(form => {
    form.addEventListener('submit', event => {
      if(!form.querySelector('[name="id"]')?.value) event.preventDefault();
    });
  });
  document.querySelectorAll('media-gallery').forEach(gallery => {
    gallery.querySelectorAll('[data-target]').forEach(button => button.addEventListener('click', () => {
      const media = document.getElementById(button.dataset.target);
      media?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }));
  });
});
if(!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.header = document.getElementById('shopify-section-amele-header');
      if(!this.header) return;
      this.lastScroll = window.scrollY;
      this.onScroll = () => {
        const position = window.scrollY;
        const focused = this.header.contains(document.activeElement);
        const open = this.header.querySelector('details[open], .amele-popup-overlay.is-visible');
        this.header.classList.toggle('al-header-hidden', position > this.header.offsetHeight && position > this.lastScroll && !focused && !open);
        this.lastScroll = position;
      };
      window.addEventListener('scroll',this.onScroll,{passive:true});
    }
    disconnectedCallback() { window.removeEventListener('scroll',this.onScroll); }
  });
}
